import { getResponseData } from "../../../../reactQuery/response";

export function formatWorkflowRows(workflows = []) {
  return workflows.map((workflow) => ({
    id: workflow.workflow_id,
    col1: workflow.workflow_name,
    col2: workflow.steps.map((step) => ({
      status: step.status,
      workflowstep_id: step.workflow_step_id,
      is_completed: step.is_completed,
      generic_step_id: step.generic_step_id,
    })),
    col3: "",
  }));
}

export function formatWorkflowStepLabel(step = "") {
  const newStep = step.replace("-", " ");
  return newStep.replace(" ", "-");
}

export function getWorkflowInitialValues(workflowData) {
  return {
    workflow_name: workflowData?.col1 || "",
    workflow_steps: workflowData?.col2
      ? workflowData.col2.map((step) => ({
          status: step.status,
          workflow_step_id: step.workflowstep_id,
          is_completed: step.is_completed,
          generic_step_id: step.generic_step_id,
        }))
      : [],
  };
}

export function buildWorkflowPayload(workflowName, workflowSteps = [], edit) {
  return {
    workflow_name: workflowName,
    workflow_steps: workflowSteps.map((step, index) => ({
      ...step,
      step_sequence: index + 1,
      status: step.status,
      ...(edit && {
        generic_step_id: step.generic_step_id,
      }),
    })),
  };
}

export function createEmptyWorkflowStep() {
  return {
    is_completed: false,
    status: "",
    workflow_step_id: null,
    generic_step_id: null,
  };
}

export function getTargetWorkflowStepOptions(fields = [], currentStep) {
  return fields.filter(
    (item) => item.workflow_step_id !== currentStep?.workflow_step_id
  );
}

export function getDefaultTargetWorkflowStepId(fields = [], currentStep) {
  return (
    getTargetWorkflowStepOptions(fields, currentStep)[0]?.workflow_step_id || ""
  );
}

export function getRemoveStepPayload(fields = [], currentStep, targetStep) {
  const selectedWorkflowStepId =
    targetStep || getDefaultTargetWorkflowStepId(fields, currentStep);

  if (!selectedWorkflowStepId || !currentStep?.workflow_step_id) {
    return null;
  }

  return {
    workflow_step_id: currentStep.workflow_step_id,
    target_workflow_step_id: selectedWorkflowStepId,
  };
}

export function getGenericWorkflowOptions(genericWorkflowStatus) {
  return getResponseData(genericWorkflowStatus,[])
}
